<template>
  <main class="winmobile">
    <section
      class="lg:h-[700px] xl:h-[811px] lg:flex items-center justify-center relative"
    >
      <div class="home4bis">
        <div
          class="lg:absolute w-full pt-[10%] lg:pt-0 h-full lg:flex justify-between items-center"
        >
          <div
            class="w-[99%] sm:w-[80%] mx-auto mt-[7%] lg:mt-0 lg:mx-0 lg:w-1/2 flex items-center justify-center h-full"
          >
            <div class="lg:pl-16 text-left text-white max-w-[520px]">
              <!-- Titre FÉLICITATIONS -->
              <img
                src="@/assets/images/win/félicitations.svg"
                alt="Félicitations"
                class="w-[85%] max-w-[360px] mx-auto lg:mx-0 mb-6 sm:mb-8"
              />

              <!-- Vous avez gagné / kit salade -->
              <div
                class="inline-flex flex-col items-start gap-3 bg-transparent mb-6 sm:mb-8"
              >
                <div
                  class="beige-box inline-flex items-center justify-center rounded-2xl bg-[#FEEFC7] px-5 pt-0.5 pb-2"
                >
                  <p
                    class="vous-avez-gagne font-barlow-condensed font-bold uppercase text-[#0D2651] text-2xl sm:text-4xl lg:text-[48px] tracking-wide"
                  >
                    VOUS AVEZ GAGNÉ
                  </p>
                </div>
                <div
                  class="inline-flex items-center justify-center rounded-2xl bg-white px-5 py-3"
                >
                  <p
                    class="font-barlow-condensed font-bold text-[#0D2651] text-xl sm:text-3xl lg:text-[40px] leading-tight text-left whitespace-nowrap"
                  >
                    {{ gain === 'kit-apero'
                      ? 'un kit collector spécial apéro !'
                      : 'un kit collector spécial salades !' }}
                  </p>
                </div>
              </div>

              <!-- Texte explicatif -->
              <p
                class="font-barlow-condensed font-bold text-white text-lg sm:text-2xl lg:text-[28px] leading-snug max-w-[420px] mb-8"
              >
                Pour bénéficier de ce gain, veuillez nous indiquer votre adresse postale.
              </p>

              <img
                v-if="gain === 'kit-apero'"
                src="@/assets/images/win/lot-apero.svg"
                alt="Kit apéro"
                class="mt-2 w-[50%] max-w-[260px]"
              />
              <img
                v-else
                src="@/assets/images/win/lot-salade.svg"
                alt="Kit salade"
                class="mt-2 w-[50%] max-w-[260px]"
              />
            </div>
          </div>
          <div
            class="lg:w-1/2 flex items-center justify-center h-full py-[5%] lg:py-0"
          >
            <div
              class="bg-white text-[5vw] sm:text-lg rounded-3xl px-4 py-6 w-[75%] mx-auto lg:w-auto lg:mx-0 mx-h-[500px]"
            >
              <Form
                class="lg:w-[470px] xl:w-[550px]"
                id="createForm"
                form_id="6904b53e310c505cd7f8a366"
                :uid="uid"
                :submission_id="id"
                server="https://api-gabarit.promo.dev"
                v-on:results="getResult"
                v-on:form_submit_loading="loading"
                @on_error="showErrorForm"
                :hideError="hiderror"
              />
              <!--<div class="mention2 pr-14">*Champs obligatoires</div>-->
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router/composables";
const route = useRoute();
const id = ref(route.params._id);
const uid = ref(route.params.uid);
const hiderror = ref(true);
const loading = ref(false);
const formId = ref(null);
const operation = ref(null);
const done = ref(false);
const error = ref(false);
const gain = ref("bob");


const fetchSubmission = async () => {
  try {
    const response = await fetch(
      `https://api-gabarit.promo.dev/api/v2/submissions/${id.value}?uid=${uid.value}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Erreur HTTP: ${response.status}`);
    }

    const data = await response.json();

    const lot = route.query.lot;
   if(lot && (lot=="bob" || lot=="parasol" || lot=="surf" || lot=="poncho" || lot=="sacplage" || lot=="sacdeplage")){
    gain.value = lot;
   } else {
    gain.value = data.lot || "bob";
   }

    const op = await fetch(
      `https://api-gabarit.promo.dev/api/v2/formdata/${data.operationId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const dataOp = await op.json();
    operation.value = dataOp;
    return data;
  } catch (error) {
    console.error(`Erreur lors de la requête pour l'ID ${id.value}:`, error);
    throw error;
  }
};

const KIT_LOTS = ["kit-apero", "kit-salade"];

onMounted(async () => {
  try {
    const sub = await fetchSubmission();

    if (!sub || sub.status !== "GAGNE") {
      window.location.href = "/formig";
      return;
    }

    if (sub.lot && String(sub.lot).toLowerCase() === "voyage") {
      window.location.href = "/gagner-voyage";
      return;
    }

    if (!KIT_LOTS.includes(String(sub.lot || "").toLowerCase())) {
      window.location.href = "/formig";
      return;
    }

    if (sub._id) {
      id.value = sub._id;
      uid.value = sub.uid;

      formId.value = operation.value.forms[0]._id;
    } else {
      console.error("No submission found");
    }
  } catch (e) {
    console.error(e);
  }
});

const getResult = (result) => {
  if (result) {
    done.value = true;
    location.reload();
  }
};

const showErrorForm = () => {
  loading.value = false;
  error.value = true;
};
</script>

<style scoped>
.winmobile {
  background-color: #0d2651;
  background-image: url("@/assets/images/fond-perdu.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

@media (min-width: 1024px) {
  .beige-box {
    padding: 2px 20px 8px 20px;
    gap: 10px;
  }

  .vous-avez-gagne {
    color: var(--Bleu-Petit-Navire, #0d2651);
    text-align: center;
    font-family: "Barlow Condensed";
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 60px;
    text-transform: uppercase;
  }
}
</style>
